//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import React from 'react';

import { PurchaseOption } from '@apis/campaign-requests/sampling/opportunities/samplingOpportunitiesApiModel';
import { usePurchaseOptionsContext } from '@campaigns/components/shared/purchase-options/PurchaseOptionsContext';

import { PrepaidPurchaseOptionsTableRowEditable } from './PrepaidPurchaseOptionsTableRowEditable';
import { PrepaidPurchaseOptionsTableRowReadOnly } from './PrepaidPurchaseOptionsTableRowReadOnly';

interface PrepaidPurchaseOptionsTableRowProps {
  onRequestCampaign?: (purchaseOption: PurchaseOption) => void;
  purchaseOption: PurchaseOption;
  showRequestCampaignButton?: boolean;
}

export const PrepaidPurchaseOptionsTableRow = ({
  onRequestCampaign,
  purchaseOption,
  showRequestCampaignButton,
}: PrepaidPurchaseOptionsTableRowProps) => {
  const { readOnly } = usePurchaseOptionsContext();

  return readOnly ? (
    <PrepaidPurchaseOptionsTableRowReadOnly
      onRequestCampaign={onRequestCampaign}
      purchaseOption={purchaseOption}
      showRequestCampaignButton={showRequestCampaignButton}
    />
  ) : (
    <PrepaidPurchaseOptionsTableRowEditable purchaseOption={purchaseOption} />
  );
};
